




































































import { State, Action, Getter, Mutation } from "vuex-class";
import { Component, Prop, Vue } from "vue-property-decorator";
import { pageDataType } from "../types";
import { HOST } from "../global";
@Component({
  name: "TitleDoubleTextLink",
})
export default class TitleDoubleTextLink extends Vue {
  @Prop() readonly compData!: any;
  public HOST: string = HOST;
  // openPDF(pdf: any) {
  //     var pdf = `${HOST}` + this.compData.call_to_action.url;
  //     window.open(pdf);
  //     return false;
  // }
}
